import { render, staticRenderFns } from "./ResultPanel.vue?vue&type=template&id=5c59ce67&scoped=true&"
import script from "./ResultPanel.vue?vue&type=script&lang=ts&"
export * from "./ResultPanel.vue?vue&type=script&lang=ts&"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./ResultPanel.vue?vue&type=style&index=0&id=5c59ce67&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5c59ce67",
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-ca-tester/mfe-ca-tester/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c59ce67')) {
      api.createRecord('5c59ce67', component.options)
    } else {
      api.reload('5c59ce67', component.options)
    }
    module.hot.accept("./ResultPanel.vue?vue&type=template&id=5c59ce67&scoped=true&", function () {
      api.rerender('5c59ce67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ResultPanel.vue"
export default component.exports